import Vue from 'vue';
import axios from 'axios';

export const SAVE_PROPERTIES = 'SAVE_PROPERTIES';
export const SET_PROPERTY_VALUE = 'SET_PROPERTY_VALUE';
export const CLEAR_PROPERTIES = 'CLEAR_PROPERTIES';

const reducer = (obj, curr) => ({
  ...obj,
  [`${curr.category}-${curr.property}`]: curr.value,
});

export default {
  namespaced: true,
  state: {
    loaded: false,
    properties: {},
  },
  actions: {
    init({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get('/properties');
          commit(SAVE_PROPERTIES, res.data.reduce(reducer, {}));
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  mutations: {
    [SAVE_PROPERTIES](state, properties) {
      Vue.set(state, 'properties', properties);
      Vue.set(state, 'loaded', true);
    },
    [SET_PROPERTY_VALUE](state, payload) {
      Vue.set(state.properties, payload.property, payload.value);
    },
    [CLEAR_PROPERTIES](state) {
      Vue.set(state, 'properties', {});
      Vue.set(state, 'loaded', false);
    },
  },
  getters: {
    loaded: state => state.loaded,
    properties: state => state.properties,
    getProperty: state => property => state.properties[property],
  },
};
